module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "persistent": "",
      "value": _vm.value,
      "max-width": "500px"
    },
    on: {
      "input": function($event) {
        return _vm.$emit('input')
      }
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Enter Version Name")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "",
      "error-messages": _vm.versionErrors,
      "counter": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.versionNo.$touch()
      },
      "blur": function($event) {
        return _vm.$v.versionNo.$touch()
      },
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.confirmPasscode.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.versionNo),
      callback: function($$v) {
        _vm.versionNo = $$v
      },
      expression: "versionNo"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": _vm.closeModal
    }
  }, [_vm._v(" Close ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "success",
    on: {
      "click": _vm.confirmVersionNo
    }
  }, [_vm._v("Confirm")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5264d029"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Pairing/CreatorConceptForm/VersionNoModal.vue
// module id = 2125
// module chunks = 0